// © Microsoft Corporation. All rights reserved.

import { FollowState, Topic, TopicList, TopicMap } from "./topic-data-types";

import { ActionMap } from "@msnews/experiences-redux";
import { TopicsResponse } from "./topic-data-models";

type FollowedTopicsSignature = (followedTopics: TopicMap, forceReset?: boolean) => void;
type FollowedTopicsFailedSignature = () => void;
type RecommendedTopicsSignature = (recommendedTopics: Topic[]) => void;
type RecommendedTopicsFailedSignature = () => void;
type TopicSignature = (topic: Topic) => void;
type TopicFailedSignature = () => void;
type TopicsSignature = (topicGroups: TopicsResponse) => void;
type TopicsFailedSignature = () => void;
type TopicGroupSignature = (topicList: TopicList, topicMap: TopicMap) => void;
type TopicGroupFailedSignature = (topicGroupId: string) => void;
type UpdateTopicFollowedStateSignature = (topicId: string, followState?: FollowState, useCreatedByOrder?: boolean) => void;
type UpdateTopicFollowedStateFailedSignature = (topicId: string, followState?: FollowState) => void;
type WorkTopicsSignature = (workTopics: Topic[]) => void;
type WorkTopicsFailedSignature = () => void;

/**
 * Class containing actions that apply to the topic data connector
 * @class
 */
export class TopicDataActions {
    public static followedTopics: ActionMap<FollowedTopicsSignature> = new ActionMap<FollowedTopicsSignature>("FollowedTopics");
    public static followedTopicsFailed: ActionMap<FollowedTopicsFailedSignature> = new ActionMap<FollowedTopicsFailedSignature>("FollowedTopicsFailedSignature");
    public static recommendedTopics: ActionMap<RecommendedTopicsSignature> = new ActionMap<RecommendedTopicsSignature>("RecommendedTopics");
    public static recommendedTopicsFailed: ActionMap<RecommendedTopicsFailedSignature> = new ActionMap<RecommendedTopicsFailedSignature>("RecommendedTopicsFailed");
    public static topic: ActionMap<TopicSignature> = new ActionMap<TopicSignature>("Topic");
    public static topicFailed: ActionMap<TopicFailedSignature> = new ActionMap<TopicFailedSignature>("TopicsFailed");
    public static topics: ActionMap<TopicsSignature> = new ActionMap<TopicsSignature>("Topics");
    public static topicsFailed: ActionMap<TopicsFailedSignature> = new ActionMap<TopicsFailedSignature>("TopicsFailed");
    public static topicGroup: ActionMap<TopicGroupSignature> = new ActionMap<TopicGroupSignature>("TopicGroup");
    public static topicGroupFailed: ActionMap<TopicGroupFailedSignature> = new ActionMap<TopicGroupFailedSignature>("TopicGroupFailed");
    public static updateTopicFollowedState: ActionMap<UpdateTopicFollowedStateSignature> = new ActionMap<UpdateTopicFollowedStateSignature>("UpdateTopicFollowedState");
    public static updateTopicFollowedStateFailed: ActionMap<UpdateTopicFollowedStateFailedSignature> = new ActionMap<UpdateTopicFollowedStateFailedSignature>("UpdateTopicFollowedStateFailed");
    public static workTopics: ActionMap<WorkTopicsSignature> = new ActionMap<WorkTopicsSignature>("WorkTopics");
    public static workTopicsFailed: ActionMap<WorkTopicsFailedSignature> = new ActionMap<WorkTopicsFailedSignature>("WorkTopicsFailed");
}
